import { LanguageCodes } from '../../../i18n/i18n';

export const termsOfUseLink = (langCode: string): string => {
  switch (langCode) {
    case LanguageCodes.en:
      return 'https://pro.campus.sanofi/uk/legal/terms-of-use';
    case LanguageCodes.de:
      return 'https://www.sanofi.de/de/nutzungsbedingungen';
    case LanguageCodes.sv:
      return 'https://www.campus.sanofi/se/anvandarvillkor';
    case LanguageCodes.nl:
      return 'https://www.sanofi.com/nl/nederland/terms-of-use';
    case LanguageCodes.es:
      return 'https://pro.campus.sanofi/es/legal/aviso-legal';
    default:
      return '/';
  }
};

export const privacyPolicyLink = (langCode: string): string => {
  switch (langCode) {
    case LanguageCodes.en:
      return 'https://www.sanofi.co.uk/en/privacy-policy';
    case LanguageCodes.de:
      return 'https://www.sanofi.de/de/datenschutz';
    case LanguageCodes.sv:
      return 'https://www.sanofi.com/sv/sverige/data-privacy';
    case LanguageCodes.nl:
      return 'https://www.sanofi.com/nl/nederland/privacyverklaring';
    case LanguageCodes.es:
      return 'https://pro.campus.sanofi/es/legal/politica-de-privacidad';
    default:
      return '/';
  }
};

export const hcpPortalLink = (langCode: string): string => {
  switch (langCode) {
    case LanguageCodes.sv:
      return 'https://www.sanofipro.se/';
    default:
      return '/';
  }
};

export const cookiePolicyLink = (langCode: string): string => {
  switch (langCode) {
    case LanguageCodes.en:
      return 'https://pro.campus.sanofi/uk/legal/cookie-policy';
    case LanguageCodes.de:
      return 'https://www.sanofi.de/de/datenschutz';
    case LanguageCodes.es:
      return 'https://pro.campus.sanofi/es/legal/politica-de-cookies';
    default:
      return '/cookie-policy';
  }
};

export const campusLink = (langCode: string): string => {
  switch (langCode) {
    case LanguageCodes.en:
      return 'https://pro.campus.sanofi/uk/type-2-diabetes';
    case LanguageCodes.de:
      return 'https://pro.campus.sanofi/de/diabetes';
    case LanguageCodes.es:
      return 'https://pro.campus.sanofi/es/diabetes-tipo-2';
    default:
      return 'https://pro.campus.sanofi/uk/type-2-diabetes';
  }
};
